import { playNumberDisplay } from './Play';

/** Accepted play warrant (aval): backs the lister's prize if the play wins. Not a support ticket. */

export type GuaranteeTicketStatus = 'pending' | 'accepted' | 'failed';

export interface GuaranteeTicket {
  clientId: string;
  status: GuaranteeTicketStatus;
  type: string;
  number: string;
  stake: number;
  createdAt: number;
  acceptedAt?: number;
  serverPlayId?: string;
  /** Human receipt code after Aval (XXXX-XXXX). */
  claimCode?: string;
  buyerNote?: string;
  /** i18n key when the server rejected the play */
  rejectKey?: string;
}

export function createGuaranteeTicket(fields: {
  clientId: string;
  type: string;
  number: string;
  number2?: string | null;
  stake: number;
  status?: GuaranteeTicketStatus;
  createdAt?: number;
  acceptedAt?: number;
  serverPlayId?: string;
  claimCode?: string;
  buyerNote?: string;
  rejectKey?: string;
}): GuaranteeTicket {
  return {
    clientId: fields.clientId,
    status: fields.status ?? 'pending',
    type: fields.type,
    number: playNumberDisplay({
      type: fields.type,
      number: fields.number,
      number2: fields.number2 ?? null,
    }),
    stake: Number(fields.stake ?? 0),
    createdAt: fields.createdAt ?? Date.now(),
    acceptedAt: fields.acceptedAt,
    serverPlayId: fields.serverPlayId,
    claimCode: fields.claimCode,
    buyerNote: fields.buyerNote,
    rejectKey: fields.rejectKey,
  };
}

export function markTicketAccepted(
  ticket: GuaranteeTicket,
  serverPlayId: string,
  opts: { acceptedAt?: number; claimCode?: string } = {},
): GuaranteeTicket {
  return {
    ...ticket,
    status: 'accepted',
    serverPlayId,
    claimCode: opts.claimCode ?? ticket.claimCode,
    acceptedAt: opts.acceptedAt ?? Date.now(),
  };
}

export function markTicketFailed(
  ticket: GuaranteeTicket,
  rejectKey?: string,
): GuaranteeTicket {
  return {
    ...ticket,
    status: 'failed',
    rejectKey: rejectKey ?? ticket.rejectKey,
  };
}
